import { Adjust, AdjustConfig, AdjustEnvironment, AdjustLogLevel } from '@awesome-cordova-plugins/adjust';
import { handleAdjustDeeplink } from "./DynamicLink.util";
import { KEYS } from "./constants";

export const initAdjust = async () => {
  const adjustEnv: AdjustEnvironment = KEYS.ADJUST_CONFIG.environment as AdjustEnvironment;
  
  const adjustConfig = new AdjustConfig(
    KEYS.ADJUST_CONFIG.appToken,
    adjustEnv
  );

  adjustConfig.setLogLevel(KEYS.ADJUST_CONFIG.logLevel as AdjustLogLevel);
  adjustConfig.setDefaultTracker(KEYS.ADJUST_CONFIG.linkToken);
  // adjustConfig.setUrlStrategy(["us.adjust.com"], true, true);
  adjustConfig.setDeferredDeeplinkCallback((deeplink : any) => {
      handleAdjustDeeplink(deeplink);
  });

  Adjust.initSdk(adjustConfig);
};